module.exports = __webpack_public_path__ + "static/media/ship-3.4030ecf5.jpg";